import React, { useEffect } from 'react';
import './ContextMenu.scss';
import { connect } from 'unistore/full/react';
import actions from './actions';
import getTypeFromUri from './get-type-from-uri';
import { Scroller } from './Scroller';
import { useHistory } from 'react-router-dom';
import spfetch from './spfetch';

export default connect(
  (
    { addedStateByUri, tracksByUri, trackFeedbackByUri, playlistsById },
    { uri, contextUri }
  ) => {
    const entityType = getTypeFromUri(uri);
    const playlist = playlistsById[uri?.split(':').pop()];
    const contextType = getTypeFromUri(contextUri);
    const context = playlistsById[contextUri?.split(':').pop()];

    return {
      isAdded: addedStateByUri[uri],
      feedback: trackFeedbackByUri[uri],
      entityType,
      contextType,
      entity:
        entityType === 'playlist'
          ? playlist
          : entityType === 'track'
          ? tracksByUri[uri]
          : null,
      context,
    };
  },
  actions
)(function ContextMenu(props) {
  const {
    uri,
    contextUri,
    feedback,
    isOpen,
    closeContextMenu,
    closeNowPlayingView,
    entity,
    entityType,
    contextType,
    isAdded,
    playlistId,
    context,
  } = props;

  const canRemoveTrack =
    contextType === 'playlist' && context?.isOwnedByCurrentUser === true;

  useEffect(() => {
    props.fetchSavedStateForUri(props.uri);
  }, [uri]);

  console.log({ entity });

  const history = useHistory();

  return (
    <div className={`ContextMenu ${isOpen ? 'ContextMenu--is-open' : ''}`}>
      <Scroller className="ContextMenu__scroller">
        <div className="ContextMenu__content">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="none"
            viewBox="0 0 375 296"
          >
            <text
              fill="#B3B3B3"
              style={{ whiteSpace: 'pre' }}
              fontSize="13"
              letterSpacing="0em"
              textAnchor="middle"
            >
              <tspan textAnchor="middle" y="276.257" x="187.5">
                {entityType === 'track'
                  ? `${entity?.artists?.[0]?.name || ''} • ${
                      entity?.album?.name || ''
                    }`
                  : null}
              </tspan>
            </text>
            <text
              fill="#fff"
              style={{ whiteSpace: 'pre' }}
              fontSize="18"
              fontWeight="bold"
              letterSpacing="0em"
            >
              <tspan x="187.5" y="249.895" textAnchor="middle">
                {entity?.name || ''}
              </tspan>
            </text>
            <path
              fill="url(#context-menu-scannable-pattern)"
              d="M108 16H268V216H108z"
            ></path>

            {entity?.id?.length === 32 ? (
              <image
                width="160"
                height="200"
                x="108"
                y="16"
                href={entity?.imageUrl}
              />
            ) : (
              <image
                width="160"
                height="200"
                x="108"
                y="16"
                href={
                  uri
                    ? `https://scannables.scdn.co/uri/800/${encodeURIComponent(
                        uri
                      )}`
                    : ''
                }
              />
            )}
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="375"
            height="56"
            fill="none"
            viewBox="0 0 375 56"
          >
            <text
              fill="#fff"
              style={{ whiteSpace: 'pre' }}
              fontSize="16"
              fontWeight="450"
              letterSpacing="0em"
            >
              <tspan x="60" y="33.24">
                {isAdded ? 'Liked' : 'Like'}
              </tspan>
            </text>

            {isAdded ? (
              <g transform="translate(26, 19)">
                <path
                  d="M18.3835 1.61419C16.3515 -0.417814 13.1285 -0.530814 10.9615 1.27219C10.9615 1.27219 10.5575 1.62019 9.9995 1.62019C9.4255 1.62019 9.0375 1.27219 9.0375 1.27219C6.8705 -0.530814 3.6475 -0.417814 1.6155 1.61419C-0.5385 3.76819 -0.5385 7.26119 1.6155 9.41519L8.4795 17.4512C9.2775 18.3862 10.7225 18.3862 11.5215 17.4512L18.3855 9.41519C20.5375 7.26119 20.5375 3.76919 18.3835 1.61419Z"
                  fill="#1DB954"
                />
              </g>
            ) : (
              <path
                fill="#B3B3B3"
                d="M44.738 20.185a5.984 5.984 0 00-8.098-.371c-.002.002-.283.23-.64.23-.366 0-.63-.222-.643-.232a5.983 5.983 0 00-8.095.373c-2.346 2.346-2.346 6.162-.026 8.479l6.864 8.035a2.497 2.497 0 003.802 0l6.837-8.006a6.023 6.023 0 00-.001-8.508zm-.734 7.83L37.14 36.05c-.571.669-1.71.669-2.281 0l-6.891-8.064a5.023 5.023 0 010-7.094 5.011 5.011 0 013.55-1.479 4.96 4.96 0 013.185 1.156c.056.048.553.475 1.297.475.723 0 1.232-.421 1.282-.463a4.988 4.988 0 016.749.312c1.956 1.955 1.956 5.137-.027 7.122z"
              ></path>
            )}
          </svg>

          {canRemoveTrack && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="375"
              height="56"
              fill="none"
              viewBox="0 0 375 56"
              onClick={() => {
                props.removeUriFromPlaylistClientside(context?.id, uri);
                closeContextMenu();
              }}
            >
              <text
                fill="#fff"
                style={{ whiteSpace: 'pre' }}
                fontSize="16"
                fontWeight="450"
                letterSpacing="0em"
              >
                <tspan x="60" y="33.24">
                  Remove from this playlist
                </tspan>
              </text>
              <path
                fill="#B3B3B3"
                d="M35.499 16.997c-5.799 0-10.5 4.7-10.5 10.5 0 5.799 4.701 10.5 10.5 10.5s10.5-4.701 10.5-10.5c0-5.8-4.701-10.5-10.5-10.5zm0 20c-5.238 0-9.5-4.262-9.5-9.5s4.262-9.5 9.5-9.5 9.5 4.262 9.5 9.5-4.262 9.5-9.5 9.5zm-5.5-9h11v-1h-11v1z"
              ></path>
            </svg>
          )}

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="375"
            height="56"
            fill="none"
            viewBox="0 0 375 56"
          >
            <text
              fill="#fff"
              style={{ whiteSpace: 'pre' }}
              fontSize="16"
              fontWeight="450"
              letterSpacing="0em"
            >
              <tspan x="60" y="33.24">
                Add to playlist
              </tspan>
            </text>
            <path
              fill="#B3B3B3"
              d="M33 33.058A3.487 3.487 0 0030.5 32c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5v-6.15a7.618 7.618 0 01-1 .425v3.283zM30.5 38a2.503 2.503 0 01-2.5-2.5c0-1.378 1.121-2.5 2.5-2.5 1.378 0 2.5 1.122 2.5 2.5S31.878 38 30.5 38zm7.564-16.918c.061.326.097.66.115.998L45 20.63v10.178a3.485 3.485 0 00-2.5-1.058c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5V19.395l-7.936 1.687zM42.5 35.75a2.503 2.503 0 01-2.5-2.5c0-1.379 1.122-2.5 2.5-2.5s2.5 1.121 2.5 2.5c0 1.378-1.122 2.5-2.5 2.5zM30.5 17a5.5 5.5 0 100 11 5.5 5.5 0 100-11zm3.5 6.001h-3V26h-1v-2.999h-3v-1h3V19h1v3.001h3v1z"
            ></path>
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="375"
            height="56"
            fill="none"
            viewBox="0 0 375 56"
          >
            <text
              fill="#fff"
              style={{ whiteSpace: 'pre' }}
              fontSize="16"
              fontWeight="450"
              letterSpacing="0em"
            >
              <tspan x="60" y="33.24">
                Add to queue
              </tspan>
            </text>
            <path
              fill="#B3B3B3"
              d="M38.5 22v1H45v-1h-6.5zM28 37h17v-1H28v1zm4.219-7H45v-1H34.61c-.725.46-1.53.803-2.391 1zM36 22.5a5.5 5.5 0 10-11 0 5.5 5.5 0 1011 0zm-9 .501v-1h3V19h1v3.001h3v1h-3V26h-1v-2.999h-3z"
            ></path>
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="375"
            height="56"
            fill="none"
            viewBox="0 0 375 56"
          >
            <text
              fill="#fff"
              style={{ whiteSpace: 'pre' }}
              fontSize="16"
              fontWeight="450"
              letterSpacing="0em"
            >
              <tspan x="60" y="33.24">
                Share
              </tspan>
            </text>
            <path
              fill="#B3B3B3"
              d="M40 25v1h2v11H29V26h2v-1h-3v13h15V25h-3zm-5-5.66V31h1V19.353l2.557 2.974.758-.652-3.818-4.44-3.831 4.438.757.653L35 19.34z"
            ></path>
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="375"
            height="56"
            fill="none"
            viewBox="0 0 375 56"
            onClick={() => {
              spfetch(
                `https://spclient.wg.spotify.com/inspiredby-mix/v2/seed_to_playlist/${encodeURIComponent(
                  uri
                )}?response-format=json`
              ).then(({ mediaItems }) => {
                closeNowPlayingView();
                closeContextMenu();
                history.push(
                  mediaItems?.[0]?.uri
                    ?.replace(/^spotify/, '')
                    .replace(/:/g, '/')
                );
              });
            }}
          >
            <text
              fill="#fff"
              style={{ whiteSpace: 'pre' }}
              fontSize="16"
              fontWeight="450"
              letterSpacing="0em"
            >
              <tspan x="60" y="33.24">
                Go to radio
              </tspan>
            </text>
            <path
              fill="#B3B3B3"
              d="M28.392 34.548a10.314 10.314 0 001.893 1.678l-.643.762a11.195 11.195 0 01-2.011-1.797 10.967 10.967 0 01-2.102-3.745 10.878 10.878 0 01-.5-4.262 10.864 10.864 0 011.161-4.13 11.015 11.015 0 012.667-3.375c.198-.167.456-.362.774-.584l.654.762c-.31.214-.567.409-.773.584a9.772 9.772 0 00-2.44 3.125 10.049 10.049 0 00-1.043 3.696c-.099 1.262.05 2.534.447 3.815a9.72 9.72 0 001.916 3.47zm3.715-11.06a5.906 5.906 0 00-1.768 2.566 5.926 5.926 0 00-.244 3.077 5.868 5.868 0 001.345 2.81c.389.46.877.869 1.464 1.226l-.643.761c-.642-.404-1.17-.849-1.583-1.333a6.876 6.876 0 01-1.34-2.387 7.036 7.036 0 01-.315-2.714 6.951 6.951 0 012.429-4.768 7.27 7.27 0 01.786-.571l.666.773a5.784 5.784 0 00-.797.56zm12.262-2.583a10.967 10.967 0 012.1 3.744c.45 1.377.616 2.797.5 4.262a10.863 10.863 0 01-1.16 4.13 11.015 11.015 0 01-2.666 3.376c-.207.166-.465.36-.774.583l-.655-.762c.317-.214.575-.409.774-.583a9.838 9.838 0 001.762-1.947 10.02 10.02 0 001.178-2.315 9.674 9.674 0 00.536-2.56 9.846 9.846 0 00-2.357-7.274 10.406 10.406 0 00-1.893-1.702l.643-.75a11.199 11.199 0 012.012 1.798zM33.88 25.928a2.889 2.889 0 012.119-.88 2.89 2.89 0 012.119.88 2.89 2.89 0 01.88 2.12c0 .825-.293 1.531-.88 2.119a2.89 2.89 0 01-2.12.88 2.889 2.889 0 01-2.118-.88 2.889 2.889 0 01-.881-2.12c0-.825.293-1.531.88-2.119zm.708 3.53c.393.393.863.59 1.41.59.548 0 1.018-.197 1.411-.59.393-.392.59-.863.59-1.41 0-.548-.197-1.018-.59-1.411a1.924 1.924 0 00-1.41-.59c-.548 0-1.018.197-1.411.59-.393.393-.59.863-.59 1.41 0 .548.197 1.018.59 1.411zM41.32 23.5a6.954 6.954 0 011.345 2.387c.286.877.391 1.782.316 2.714a7.009 7.009 0 01-.738 2.631 6.798 6.798 0 01-2.483 2.709l-.666-.774c.341-.207.607-.393.797-.56a5.881 5.881 0 001.459-1.833 5.865 5.865 0 00.63-2.256 6.029 6.029 0 00-.273-2.322 5.923 5.923 0 00-2.613-3.268l.643-.761c.643.404 1.17.849 1.583 1.333z"
            ></path>
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="375"
            height="56"
            fill="none"
            viewBox="0 0 375 56"
          >
            <text
              fill="#fff"
              style={{ whiteSpace: 'pre' }}
              fontSize="16"
              fontWeight="450"
              letterSpacing="0em"
            >
              <tspan x="60" y="33.24">
                View album
              </tspan>
            </text>
            <path
              fill="#B3B3B3"
              d="M35.5 16C29.149 16 24 21.148 24 27.5 24 33.851 29.149 39 35.5 39S47 33.851 47 27.5C47 21.148 41.851 16 35.5 16zm0 22C29.71 38 25 33.29 25 27.5S29.71 17 35.5 17 46 21.71 46 27.5 41.29 38 35.5 38zm0-14a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm0 6a2.503 2.503 0 01-2.5-2.5c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5z"
            ></path>
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="375"
            height="56"
            fill="none"
            viewBox="0 0 375 56"
          >
            <text
              fill="#fff"
              style={{ whiteSpace: 'pre' }}
              fontSize="16"
              fontWeight="450"
              letterSpacing="0em"
            >
              <tspan x="60" y="33.24">
                View artist
              </tspan>
            </text>
            <path
              fill="#B3B3B3"
              d="M39.962 30.421l-.961-.552a.495.495 0 01-.244-.349.493.493 0 01.112-.409l1.311-1.537A5.493 5.493 0 0041.5 24v-.5a5.521 5.521 0 00-1.74-4.014 5.454 5.454 0 00-4.125-1.475c-2.879.187-5.134 2.673-5.134 5.66V24c0 1.311.469 2.58 1.319 3.574l1.311 1.538a.493.493 0 01.112.409.489.489 0 01-.243.348l-3.213 1.847A5.514 5.514 0 0027 36.501V38h1v-1.499c0-1.616.874-3.116 2.283-3.917l3.216-1.848c.388-.223.654-.604.73-1.044a1.494 1.494 0 00-.337-1.229l-1.312-1.539A4.5 4.5 0 0131.501 24v-.329c0-2.461 1.845-4.509 4.199-4.661a4.468 4.468 0 013.377 1.206A4.457 4.457 0 0140.5 23.5v.5a4.5 4.5 0 01-1.08 2.925l-1.311 1.537a1.5 1.5 0 00.394 2.274l.479.275c.305-.229.628-.433.98-.59zM44 27.184v5.577a2.993 2.993 0 00-2.013-.788 3.017 3.017 0 00-3.014 3.014 3.017 3.017 0 003.014 3.014A3.017 3.017 0 0045 34.986v-6.071l1.99 1.149.5-.866L44 27.184zM41.986 37a2.016 2.016 0 01-2.014-2.014c0-1.11.903-2.014 2.014-2.014a2.015 2.015 0 010 4.028z"
            ></path>
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="375"
            height="56"
            fill="none"
            viewBox="0 0 375 56"
          >
            <text
              fill="#fff"
              style={{ whiteSpace: 'pre' }}
              fontSize="16"
              fontWeight="450"
              letterSpacing="0em"
            >
              <tspan x="60" y="33.24">
                Report
              </tspan>
            </text>
            <path
              fill="#B3B3B3"
              d="M38.875 25L44 19H29v12h.011v7h1v-7H44l-5.125-6zm-8.864-5h11.82l-3.716 4.351-.555.649.555.649L41.831 30h-11.82V20z"
            ></path>
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="375"
            height="56"
            fill="none"
            viewBox="0 0 375 56"
          >
            <text
              fill="#fff"
              style={{ whiteSpace: 'pre' }}
              fontSize="16"
              fontWeight="450"
              letterSpacing="0em"
            >
              <tspan x="60" y="33.24">
                Song credits
              </tspan>
            </text>
            <path
              fill="#B3B3B3"
              d="M29.027 24.189a3.905 3.905 0 01-.939-2.541v-.29c0-2.141 1.603-3.922 3.65-4.054a3.868 3.868 0 012.937 1.048c.241.227.438.483.611.753.288-.163.587-.306.895-.43a4.88 4.88 0 00-.822-1.052 4.88 4.88 0 00-3.685-1.317c-2.572.166-4.586 2.385-4.586 5.051v.29c0 1.17.419 2.304 1.179 3.191l1.156 1.356a.373.373 0 01.086.313.375.375 0 01-.186.266l-2.835 1.629A4.93 4.93 0 0024 32.678V34h1v-1.322c0-1.405.76-2.709 1.984-3.405l2.837-1.631a1.379 1.379 0 00.362-2.095l-1.156-1.358zm15.487 9.216l-2.837-1.63a.383.383 0 01-.101-.58l1.156-1.356a4.915 4.915 0 001.179-3.192v-.441a4.929 4.929 0 00-1.553-3.584 4.884 4.884 0 00-3.685-1.317c-2.571.167-4.586 2.386-4.586 5.052v.29c0 1.17.419 2.304 1.179 3.191l1.156 1.356a.376.376 0 01.086.313.375.375 0 01-.186.266l-2.834 1.629A4.93 4.93 0 0031 37.677V39h1v-1.323c0-1.405.76-2.708 1.984-3.405l2.837-1.631a1.379 1.379 0 00.362-2.095l-1.157-1.357a3.908 3.908 0 01-.939-2.542v-.29c0-2.141 1.603-3.922 3.65-4.054a3.866 3.866 0 012.936 1.048 3.875 3.875 0 011.237 2.855v.441c0 .932-.333 1.835-.939 2.543l-1.157 1.356a1.38 1.38 0 00.362 2.095l2.839 1.632A3.922 3.922 0 0146 37.677V39h1v-1.323a4.924 4.924 0 00-2.486-4.272z"
            ></path>
          </svg>
        </div>
      </Scroller>
      <div className="ContextMenu__close-button" onClick={closeContextMenu}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 375 92"
        >
          <text
            fill="#fff"
            style={{ whiteSpace: 'pre' }}
            fontSize="16"
            letterSpacing="0em"
          >
            <tspan x="166.391" y="29.24">
              Close
            </tspan>
          </text>
        </svg>
      </div>
    </div>
  );
});
